import { Dialog } from "radix-ui";
import { Close } from "../../assets/svgs/icons";

const SubscriptionPopup = ({
  title = "",
  message = "",
  open = false,
  onClose = () => {},
}) => {
  return (
    <Dialog.Root open={open} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/40 z-50" />
        <Dialog.Content className="box-border bg-white flex flex-col gap-6 items-center justify-center max-w-[328px] w-full overflow-hidden pb-4 pt-10 px-4 rounded-[20px] shadow-[0px_6px_12px_-6px_rgba(0,0,0,0.12),0px_8px_24px_-4px_rgba(0,0,0,0.08)] fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50">
          <Dialog.Close asChild>
            <button
              className="absolute right-0 top-0 p-3 w-12 h-12 flex items-center justify-center"
              aria-label="닫기"
            >
              <Close className="w-6 h-6" style={{ fill: "#B2B2B2" }} />
            </button>
          </Dialog.Close>

          <div className="flex flex-col gap-4 items-start w-full">
            {/* 제목 */}
            <div className="flex flex-col gap-3 items-start w-full">
              <div className="font-bold text-[#212121] text-[16px] leading-[24px] tracking-[-0.32px] text-center w-full">
                {title}
              </div>
            </div>

            {/* 메시지 */}
            <div className="flex flex-col gap-3 items-start w-full">
              <div className="font-medium text-[#555] text-[14px] leading-[20px] tracking-[-0.28px] text-center w-full whitespace-pre-wrap">
                {message}
              </div>
            </div>
          </div>

          {/* 닫기 버튼 */}
          <div className="flex gap-4 w-full">
            <button
              className="flex-1 flex h-10 px-5 justify-center items-center rounded-lg bg-[#212121] text-white text-sm font-semibold leading-5 tracking-[-0.28px]"
              onClick={onClose}
            >
              닫기
            </button>
            <button
              className="flex-1 flex h-10 px-5 justify-center items-center rounded-lg bg-[#6d2ef2] text-white text-sm font-semibold leading-5 tracking-[-0.28px]"
              onClick={() => window.Android?.openSubscriptionManagement()}
            >
              구독관리
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default SubscriptionPopup;
